module.exports = __webpack_public_path__ + "static/media/cloud-c-v3@2x.afde40ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-c-v3@2x.png
// module id = 95
// module chunks = 0